import { usePermissions } from '../../../contexts/AuthContext';
import { hasPermission, P } from '../../../utils/permissions';

/**
 * Whether the reader can open Timesheets → Reports, where logged utilisation
 * lives. The Timesheets page leaves its Reports tab out without
 * `view:reports:operational`, so a link there would land somewhere else.
 */
export function useCanOpenLoggedUtilisation(): boolean {
  const { permissions } = usePermissions();
  return hasPermission(permissions, P.VIEW_REPORTS_OPERATIONAL);
}
